import { IDirective, IScope } from 'angular';

export interface IGmcOnloadScope extends IScope {
  gmcOnload: ( event ) => void;
}

export function gmcOnloadDirective(): IDirective {
  return {
    restrict: 'A',
    scope: {
      gmcOnload: '&'
    },
    link: ( scope: IGmcOnloadScope, element, attrs ) => {
      element.on('load', ( event ) => {
        scope.gmcOnload({ $event: event });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-onload/gmc-onload.ts